var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16264",
    "data-name": "Group 16264",
    transform: "translate(-2 -2)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16263",
    "data-name": "Group 16263",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(10 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18975",
    "data-name": "Path 18975",
    d: "M9.184,14.2h6.2a3.281,3.281,0,0,0-6.2,0Z",
    transform: "translate(-1.282 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18976",
    "data-name": "Path 18976",
    d: "M20.7,2H5.3A3.3,3.3,0,0,0,2,5.3v9.9H7.611a5.494,5.494,0,0,1,2.661-3.646,3.3,3.3,0,1,1,5.456,0A5.5,5.5,0,0,1,18.389,15.2H24V5.3A3.3,3.3,0,0,0,20.7,2Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18977",
    "data-name": "Path 18977",
    d: "M2,19.3a3.3,3.3,0,0,0,3.3,3.3H20.7A3.3,3.3,0,0,0,24,19.3V16H2Zm5.5-2.2h11v2.2H7.5Z",
    transform: "translate(-2 -0.6)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.731665447027b541fbe3170b6dab96f4.svg";
export { ForwardRef as ReactComponent };